import styled from "styled-components/macro";

export const StyledInnerPage = styled.div`
	padding: 1rem;
	display: inline-block;
`;

export const StyledConnectFacebookButton = styled.button`
	background: #1877f2;
	overflow: hidden;
	position: relative;
	border: 1px solid #1877f2;
	border-radius: 4px;
	color: #fcfcfd;
	font-style: normal;
	font-weight: 600;
	line-height: 16px;
	font-size: 16px;
	padding: 10px 21px;
	margin: 16px 0 0 0;
	&:hover {
		cursor: pointer;
	}
`;
export const StyledCheckboxWrapper = styled.div`
	display: flex;
	flex-direction: row;
	justify-content: flex-start;
	align-items: center;
	gap: 0.5rem;
	label {
		font-weight: normal;
		font-size: 14px;
		line-height: 21px;
		color: #575e68;
	}
	input {
		border: 1px solid #acb8b9;
		size: 3rem;
	}
`;

export const StyledCodeSnippet = styled.pre`
	background: #f4f6f8;
	border: 1px solid #acb8b9;
	box-sizing: border-box;
	border-radius: 4px;
	padding: 20px;
	font-size: 20px;
	white-space: pre-wrap;
	word-wrap: break-word;

	code {
		color: #3a5558;
		max-width: 100%;
		display: block;
		font-size: 10px;
		font-weight: 500;
		line-height: 150%;
	}
`;

export const StyledOptionsContent = styled.div`
	font-size: 14px;
	line-height: 21px;
	color: #3a5558;

	display: flex;
	flex-direction: column;
	gap: 1rem;
	align-items: start;
`;
